import { getHelpNode, getNextHelpNode, helpFullSlugs } from '$lib/help'
import type { Seo } from '$lib/types'
import { error } from '@sveltejs/kit'

export const entries = () => helpFullSlugs.map((slugs) => ({ slugs }))

export const load = ({ params }) => {
  const node = getHelpNode(params.slugs)

  if (!node) {
    error(404, 'Help page not found')
  }

  const seo: Seo = {
    title: `${node.title} - Pausly help`,
    fullyReplaceTitle: true,
    description: node.teaser,
  }

  return {
    node,
    next: getNextHelpNode(node.full_slug) ?? null,
    seo,
  }
}
